import type { ButtonProps } from '@petsmart-ui/sparky';
import { Button } from '@petsmart-ui/sparky';
import classNames from 'classnames';
import type { ReactElement } from 'react';
import React from 'react';

export function getButtonText(isActivated?: boolean, loading?: boolean): string | undefined {
    if (!loading) {
        return isActivated ? `Activated` : `Activate`;
    }

    return undefined;
}

/** ------------------------------------
 * component
 * ---------------------------------- */

type OfferCardButtonProps = ButtonProps & {
    isActivated?: boolean;
};

export function OfferCardButton({
    className,
    isActivated,
    fullWidth,
    loading,
    onClick,
    size,
}: OfferCardButtonProps): ReactElement {
    const componentClassName = classNames('c-offer-card-button', className, {
        'offer-card-button-check': !fullWidth && isActivated,
        'offer-card-button-plus': !fullWidth && !isActivated,
        'offer-card-button-full-width': fullWidth,
    });

    const text = getButtonText(isActivated, loading);

    return fullWidth ? (
        <Button
            className={componentClassName}
            disabled={loading}
            iconName={isActivated ? 'check' : undefined}
            iconSize={size === 'lg' ? 'xl' : 'xs'}
            loading={loading}
            onClick={onClick}
            fullWidth
            size={size}
            text={text}
            variant={isActivated ? 'active' : 'primary'}
        />
    ) : (
        <Button
            className={componentClassName}
            circle
            disabled={loading}
            iconName={isActivated ? 'check' : 'plus'}
            iconSize={isActivated ? 'lg' : 'md'}
            loading={loading}
            onClick={onClick}
            variant={isActivated ? 'active' : undefined}
        />
    );
}
